module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_1-ded016974fbf442fae55250ac39b37fe.png";